import { ChatThreadModel, ThreadApi } from "../../../@api";

import { ChatThreadExtendedModel } from "../../models/interfaces";
import { IStoreContext } from "../../stores/StoreContext";
import { ThreadApiService } from "../ApiServices/ThreadApiService";
import GenericService from "../GenericService";

export class ThreadService extends GenericService<ThreadApi, ThreadApiService> {
  constructor(storeContext: IStoreContext) {
    super(storeContext, ThreadApi, ThreadApiService);
  }

  public async loadThreads(abortController?: AbortController): Promise<void> {
    this.storeContext.threadStore.loadingThreads = true;
    const threads = this.storeContext.threadStore.threads;

    try {
      const updatedThreads = await this.apiService.getAllUserThreads({
        signal: abortController?.signal,
      });
      this.storeContext.threadStore.threads = updatedThreads.map((updatedThread: ChatThreadModel) => {
        const extendedThread = threads.find((thread: ChatThreadExtendedModel) => thread.id === updatedThread.id) || {
          ...updatedThread,
          pendingPrompt: undefined,
        };

        return extendedThread;
      });
    } finally {
      this.storeContext.threadStore.loadingThreads = false;
    }
  }

  public async deleteThreadById(threadId: string): Promise<void> {
    return this.apiService.deleteThreadById({ threadId });
  }
}
